
class Home {
    constructor() {
        this.events();
      
           
          
    }

    events() {
        this.showMenuDropdown()
        this.closeMenuDropdown()
        this.openMenuContent()
        this.showScrollTop()
        this.handleSection6()
        this.scrolltop()
        this.showCarFooter()
        this.initAOS()
        this.handeChangeNameCar()
        this.onchangeCheckBox()
        this.showSeemoreImage()
    }
    initAOS(){
        AOS.init({disable: 'mobile'});

    }
    showCarFooter(){
        $(document).on('click','.footer-menu-item-car-footer',function(){
            $(this).toggleClass("active");
        })
    }
    scrolltop(){
        if ($('#button-top').length > 0) {
            var btnTop = $('#button-top')
            var scrollbtn =  $('.scroll-top');
            $(window).scroll(function() {
                if ($(window).scrollTop() > 300) {
                    btnTop.addClass('show-button-top')
                    scrollbtn.addClass('d-block')
                    scrollbtn.removeClass('d-none')
                    

                } else {
                    btnTop.removeClass('show-button-top')
                   scrollbtn.removeClass('d-block')
                   scrollbtn.addClass('d-none')
                }
            })
            btnTop.on('click', function(e) {
                e.preventDefault()
                $('html, body').animate({ scrollTop: 0 }, '300')
            })
        }
    }
    showSeemoreImage(){
        $('.grid-conainer-wrapper .item-grid:lt(2)').show();
        $('.less-library-image').hide();
        document.getElementsByClassName("item-grid").length;
        var items =  document.getElementsByClassName("item-grid").length;
        var shown = Number(items-2);
        $('.semore-library-image').click(function () {
            $('.less-library-image').show();
            shown = $('.grid-conainer-wrapper .item-grid:visible').length+shown;
            if(shown< items) {
                $('.grid-conainer-wrapper .item-grid:lt('+shown+')').show(300);
            } else {
                $('.grid-conainer-wrapper .item-grid:lt('+items+')').show(300);
                $('.semore-library-image').hide();
            }
        });
        $('.less-library-image').click(function () {
            $('.grid-conainer-wrapper .item-grid').not(':lt(2)').hide(300);
            $('.semore-library-image').show();
            $('.less-library-image').hide();
        });
    }
    showMenuDropdown(){
        $(document).on('click', '.menu-item-has-children', function () {
            $(this).find('.icon-drop-show').css('transform', 'rotate(180deg)');
            $(this).find('.menu-sub-items').show('300');
            $(this).addClass("close-menu-drop");
        })
    }
    closeMenuDropdown(){
        $(document).on('click', '.close-menu-drop', function () {
            $(this).find('.icon-drop-show').css('transform', 'rotate(0deg)');
            $(this).find('.menu-sub-items').hide('300');
            $(this).removeClass("close-menu-drop");
        })
    }

    openMenuContent(){
        $(document).on('click', '.header-right-open-menu', function () {
            $('.menu-mobile-container').css('transform', 'translateX(0%)');
            $('.menu-mobie-fixed').show();
        })
        $(document).on('click', '.menu-mobie-fixed', function () {
            $('.menu-mobile-container').css('transform', 'translateX(100%)');
            $('.menu-mobie-fixed').hide();
        })
        $(document).on('click', '.menu-mobile-wrap--top__close', function () {
            $('.menu-mobile-container').css('transform', 'translateX(100%)');
            $('.menu-mobie-fixed').hide();
        })
        $(document).on('click', '.header-right-menu--item', function () {
            $('.menu-mobile-container').css('transform', 'translateX(100%)');
            $('.menu-mobie-fixed').hide();
        })

        
    }
    showScrollTop(){
        if ($('#button-top').length > 0) {
            var btnTop = $('#button-top')
            $(window).scroll(function() {
                if ($(window).scrollTop() > 300) {
                    btnTop.addClass('show-button-top')
                } else {
                    btnTop.removeClass('show-button-top')
                }
            })
            btnTop.on('click', function(e) {
                e.preventDefault()
                $('html, body').scrollTop(0);
                return false;
            })
        }
    }
    handleSection6(){
        $(document).on('click', '.section6__left-item', function(){
            $(this).siblings().removeClass('active')
            $(this).addClass('active')
            $('.section6__right').addClass('fade')
            $('.section6__right-img-main').attr('href', $(this).data('img'))
            $('.section6__right-img-main img').attr('src', $(this).data('img'))
            setTimeout(function(){
                $('.section6__right').removeClass('fade')
            }, 400)
        })
    }
    handeChangeNameCar(){
        $(document).ready(function() {
            $('.nav-link').click(function() {
                var color = $(this).data('name')
                var colorVi = $(this).data('vi')
                var el = $(this).parents('.bottom--top').find('h4.name-en')
                if (el.length) {
                    el[0].innerHTML = color
                    if ($('.fancybox-container input[name="car_color"]').length) {
                        $('.fancybox-container input[name="car_color"]')[0].value = color
                    }
                }
                var vi = $(this).parents('.bottom--top').find('h4.name-vi')
                if (vi.length) {
                    vi[0].innerHTML = colorVi
                    if ($('.fancybox-container input[name="car_color"]').length) {
                        $('.fancybox-container input[name="car_color"]')[0].value = color
                    }
                }
            })
        })
    }
    onchangeCheckBox(){
        let priceTotal = 0
        let price_interior = 0
        let price_seat = 0
        let elementColor = $('.furniture_color input[type="checkbox"]')
        let elementSeat = $('.furniture_seat input[type="checkbox"]')
        elementColor.on('change',function(){
            const itemSelected = $(this).data('item')
            const priceCurrent =  itemSelected.price
            const dataColor = $(this).data('color')
            if($(this).prop('checked')){
                price_interior = parseInt(dataColor.price_interior)
                $(this).parent('.checkbox').siblings().find('input').prop('checked',false)
                $(`#animatedModal10${itemSelected.key + 1 } input[name="seat"]`).val(dataColor.color_name ?? '')
            }
            else{
                price_interior = 0
            }    
           priceTotal = parseInt(priceCurrent) + parseInt(price_seat) + parseInt(price_interior)
           $(`#price_car-${itemSelected.key}`).val(priceTotal)
           $(`#animatedModal10${itemSelected.key + 1 } input[name="price_car"]`).val(priceTotal)
          
           $(`#animatedModal10${itemSelected.key + 1 } #car_price`).attr('data-price',priceTotal)
           $(`#animatedModal10${itemSelected.key + 1 } #car_price`).html(new Intl.NumberFormat().format(priceTotal) + ' ' + 'VND')
          $(`.item-${itemSelected.key} .append`).html( new Intl.NumberFormat().format(priceTotal) + ' ')
        
        })
        elementSeat.on('change',function(){
            const itemSelected = $(this).data('item')
            const priceCurrent =  itemSelected.price
            const dataSeat = $(this).data('seat')
            if($(this).prop('checked')){
                price_seat = parseInt(dataSeat.price_seat)
                $(this).parent('.checkbox').siblings().find('input').prop('checked',false)
                $(`#animatedModal10${itemSelected.key + 1 } input[name="seat"]`).val(dataSeat.seat_name ?? '')
            }
            else{
                price_seat = 0
            }
           priceTotal = parseInt(priceCurrent) + parseInt(price_seat) + parseInt(price_interior)
           $(`#price_car-${itemSelected.key}`).val(priceTotal)
           $(`#animatedModal10${itemSelected.key + 1 } input[name="price_car"]`).val(priceTotal)
          
           $(`#animatedModal10${itemSelected.key + 1 } #car_price`).attr('data-price',priceTotal)
           $(`#animatedModal10${itemSelected.key + 1 } #car_price`).html(new Intl.NumberFormat().format(priceTotal) + ' ' + 'VND')
          $(`.item-${itemSelected.key} .append`).html( new Intl.NumberFormat().format(priceTotal) + ' ')
        
        })
       
    }

        
}
export default Home

